import MyTable from './table.vue';

MyTable.install = function(Vue){
  Vue.component('myTable', table);
};

export default MyTable;